import { render, staticRenderFns } from "./settings.page.vue?vue&type=template&id=7493ab1f&scoped=true"
import script from "./settings.page.vue?vue&type=script&lang=js"
export * from "./settings.page.vue?vue&type=script&lang=js"
import style0 from "./settings.page.vue?vue&type=style&index=0&id=7493ab1f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7493ab1f",
  null
  
)

export default component.exports